import createLucideIcon from '../createLucideIcon';
import type { LucideIconNode, LucideIconData } from '../types';

export const __iconData: LucideIconData = {
  name: 'barrel',
  size: 24,
  node: [
    ['path', { d: 'M10 3a41 41 0 000 18', key: '1f9k6x' }],
    ['path', { d: 'M14 3a41 41 0 010 18', key: '1qo28r' }],
    [
      'path',
      {
        d: 'M16.997 21a2 2 0 001.68-.92 15.25 15.25 0 000-16.16 2 2 0 00-1.68-.92h-10a2 2 0 00-1.681.92 15.25 15.25 0 000 16.16 2 2 0 001.681.92z',
        key: '1nrwe5',
      },
    ],
    ['path', { d: 'M3.54 16h16.914', key: 'jntgtt' }],
    ['path', { d: 'M3.54 8h16.914', key: '14pf7i' }],
  ],
};

/**
 * @deprecated Access `__iconData` instead.
 */
export const __iconNode: LucideIconNode[] = __iconData.node;

/**
 * @component @name Barrel
 * @description Lucide SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgM2E0MSA0MSAwIDAwMCAxOCIgLz4KICA8cGF0aCBkPSJNMTQgM2E0MSA0MSAwIDAxMCAxOCIgLz4KICA8cGF0aCBkPSJNMTYuOTk3IDIxYTIgMiAwIDAwMS42OC0uOTIgMTUuMjUgMTUuMjUgMCAwMDAtMTYuMTYgMiAyIDAgMDAtMS42OC0uOTJoLTEwYTIgMiAwIDAwLTEuNjgxLjkyIDE1LjI1IDE1LjI1IDAgMDAwIDE2LjE2IDIgMiAwIDAwMS42ODEuOTJ6IiAvPgogIDxwYXRoIGQ9Ik0zLjU0IDE2aDE2LjkxNCIgLz4KICA8cGF0aCBkPSJNMy41NCA4aDE2LjkxNCIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/barrel
 * @see https://lucide.dev/guide/packages/lucide-react - Documentation
 *
 * @param {Object} props - Lucide icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Barrel = createLucideIcon(__iconData);

export default Barrel;
